import { useEffect, useState } from 'react';

import EditIcon from '@/components/common/OptionButton/icons/Edit/EditIcon';
import ArrowIcon from '@/components/common/OptionButton/icons/Arrow/ArrowIcon';
import OptionButton from '@/components/common/OptionButton/OptionButton';
import BillingCadenceModal from './components/BillingCadenceModal';
import {
  useSelectedLines
} from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';
import { EnvUtils } from '@/utils/env.utils';
import { EvoBillingCyclesModal } from '@/pages/ContractDetails/RightPanel/Billing/EvoBillingCyclesModal';
import { useGetUserRole } from '@/hooks/identity/useGetUserRole';
import { UserRole } from '@/config/roles.config';

export default function BillingCadenceContainer() {
  const [isOpenBillingCadenceModal, setIsOpenBillingCadenceModal] = useState(false);
  const selectedLineRows = useSelectedLines();
  const { getUserRole } = useGetUserRole();
  const [userRole, setUserRole] = useState<UserRole>();

  useEffect(() => {
    const getRole = async () => {
      const roleName = await getUserRole();
      setUserRole(roleName);
    };
    getRole();
  }, [getUserRole]);

  const isReaderRole = userRole === UserRole.READER;
  const isUserRole = userRole === UserRole.USER;
  const isReadOnly = isReaderRole || isUserRole;

  const handleOnClick = () => {
    setIsOpenBillingCadenceModal(true);
  };

  if (!selectedLineRows.length) {
    return null;
  }

  return (
    <>
      {isOpenBillingCadenceModal && (
        EnvUtils.isSelectiveBillingEnabled() ? (
          <EvoBillingCyclesModal
            open={isOpenBillingCadenceModal}
            onOpenChange={setIsOpenBillingCadenceModal}
          />
        ) : (
          <BillingCadenceModal
            onClose={() => setIsOpenBillingCadenceModal(false)}
            isReadOnly={isReadOnly}
          />
        )
      )}

      <OptionButton
        onClick={handleOnClick}
        Icon={isReadOnly ? <ArrowIcon /> : <EditIcon />}
      >
        {isReadOnly ? 'Review Billing Cycles' : 'Update/Review Billing Cycles'}
      </OptionButton>
    </>
  );
}
